export default "/images/garmin_stream_instruction.webp"